import React, { useState, useEffect } from 'react';
import { Button, Table, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReactDOMServer from 'react-dom/server';
import convertToAscii from 'helpers/ConvertToASCII';
import { parseDateBR } from 'helpers/date';
import { CurrencyPlainText } from 'helpers/Currency';
import flatten from 'helpers/flatten';


const ExportTable = ({
  table,
  data,
  model,
  fileName,
  buttonText,
  fields,
  expandRow,
  filters = {page: 1}
})=>{
  const { t } = useTranslation();
  const [isExport, setExport] = useState(false);

  buttonText = buttonText ? buttonText : 'Exportar';

  const format = (table, fileName) => {
    return (`
    <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
      <head>
        <!--[if gte mso 9]>
          <xml>
            <x:ExcelWorkbook>
                <x:ExcelWorksheets>
                  <x:ExcelWorksheet>
                      <x:Name>${fileName || 'Worksheet'}</x:Name>
                      <x:WorksheetOptions>
                        <x:DisplayGridlines/>
                      </x:WorksheetOptions>
                  </x:ExcelWorksheet>
                </x:ExcelWorksheets>
            </x:ExcelWorkbook>
          </xml>
        <![endif]-->
        <meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>
      </head>
      <body>
        ${convertToAscii(ReactDOMServer.renderToString(table), [160])}
      </body>
    </html>`
    )
  };

  const getData = async() => {
    if(typeof(data) === 'function'){
      let _r = [];
      let page = 1;
      let hasMorePage = true;
      try {
        do {
          let response = await data({...filters, page, per_page: null});
          response = response.data;
          _r = [..._r,...response.data];
          page++;
          hasMorePage = response.pagination.next_page && response.pagination.next_page <= response.pagination.last_page;
        } while (hasMorePage);
        return _r;
      } catch (error) {
        return {};
      }
    }
    return data;
  };

  const getTable = (reports) => {
    if(table){
      return table(reports);
    }
    return (
      <Table bordered hover responsive id="general-report-table">
        <thead style={{background: 'aliceblue'}}>
          <tr>
            {fields.map((field, k) => (
              <th className="text-center align-middle" key={k}>
                {field.label?field.label:t(`label:${field.name}`)}
              </th>
            ))}
            {expandRow?expandRow.cols.map((item,key)=>{
              let colspan = (
                expandRow.colspanHeader
                &&
                expandRow.colspanHeader.filter(item=>item[0]===key).length>0
                ?
                expandRow.colspanHeader.filter(item=>item[0]===key)[0][1]
                :
                1
              );
              return <th className="text-center align-middle" colSpan={colspan} key={key}>
                {item}
              </th>
            }):""}
          </tr>
          {expandRow && expandRow.subHeader?(
            <tr>
              {fields.map((field, k) => (<th key={k}></th>))}
              {(()=>{
                let _r = [];
                for (let i = 0; i < expandRow.cols.length; i++) {
                  let colspan = (
                    expandRow.colspanHeader
                    &&
                    expandRow.colspanHeader.filter(item=>item[0]===i).length>0
                    ?
                    expandRow.colspanHeader.filter(item=>item[0]===i)[0][1]
                    :
                    1
                  );
                  let list_aux = expandRow.subHeader.filter(item=>item[0]===i);
                  for (let j = 0; j < colspan; j++) {
                    if(list_aux.length>0){
                      let aux = list_aux[0];
                      try {
                        _r.push(<th>{aux[1][j]}</th>);
                      } catch (error) {
                        _r.push(<th></th>);
                      }

                    } else {
                      _r.push(<th></th>);
                    }
                  }
                }
                return _r;
              })()}
            </tr>
          ):""}
        </thead>
        <tbody>
          {reports.map((report, k) => {
            const data = flatten(report);
            
            return (
              <>
                <tr key={k}>
                  {fields.map((field, k) => {
                    let text = 0;
                    if(field.mask){
                      return (
                        <td className="text-center align-middle" key={k}>
                          {field.mask(report)}
                        </td>
                      );
                    }
                    switch (field.type) {
                      case 'string':
                        text = !!data[field.key] ? data[field.key] : '--';
                        break;
                      case 'date':
                        text = !!data[field.key]
                          ? parseDateBR(data[field.key])
                          : '--';
                        break;
                      case 'currency':
                        text = !!data[field.key] ? (
                          <CurrencyPlainText
                            value={parseFloat(data[field.key])}
                          />
                        ) : (
                          '--'
                        );
                        break;
                      case 'collected':
                        report.funds.map(fund => {
                          text += parseInt(fund.value_currency_real);
                        });
                        text = text.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                        break;
                      case 'invoiced amount':
                        report.actions.map(action => {
                          if(action.status_id == 17 || action.status_id == 18){
                            action.all_values.map(value => {
                              text += parseInt(value.real_value)
                            });
                          }
                        });
                        text = text.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                        break;
                      case 'total spent':
                        report.actions.map(action => {
                          action.all_values.map(value => {
                            text =
                              action.status_id !== 19
                                ? (text += parseInt(value.actual_value))
                                : 0;
                          });
                        });
                        text = text.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                        break;
                      case 'margin':
                        let margin = 0;
                        report.actions.map(action => {
                            margin += action.margin.margin;
                        });

                        // margin = collected - spent - expire;
                        text += margin;
                        text = text.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                        break;
                      case 'received':
                        let assign = 0;
                        report.actions.map(action => {
                          action.refunds.map(value => {
                            assign += value.value
                          });
                        });
                        text += assign;
                        text = text.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                        break;
                      case 'to profit':
                        let profit = 0;
                        let received = 0;
                        report.actions.map(action => {
                          action.all_values.map(value => {
                            if (action.status_id === 13) {
                              profit += parseInt(value.actual_value);
                            } 
                            // else if (action.status_id === 18) {
                            //   received += parseInt(value.actual_value);
                            // }
                          });
                        });

                        if (profit !== 0) {
                          text += profit;
                        } 
                        // else {
                        //   text += received;
                        // }

                        text = text.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                        break;
                      case 'two_string':
                        var text_list = field.key.split('|')
                        text = data[text_list[0]];
                        for (let index = 1; index < text_list.length; index++) {
                          text += ' / '+data[text_list[index]];
                        }
                        break;
                      default:
                        text = data[field.key];
                        break;
                    }

                    if (!!field.trans) text = t(`${field.name}:${text}`);

                    return (
                      <td className="text-center align-middle" key={k}>
                        {text}
                      </td>
                    );
                  })}
                </tr>
                {expandRow?(()=>{
                  let _r = [];
                  for (let i = 0; i < fields.length; i++) {
                    _r.push(<td></td>);
                  }
                  return report[expandRow.field].map((item,key)=>{
                    return <tr key={key} style={{msoOutlineLevel:"1"}}>
                      {_r}
                      {item.map((item2)=>{
                        return item2.split("\n").map((item3,key3)=>{
                          return <td key={key3} style={{dataCellType:"date"}}>{item3}</td>
                        });
                      })}
                    </tr>;
                  });
                })():""}
              </>
            );
          })}
        </tbody>
      </Table>
    );
  }

  const exportar = async() => {
    setExport(true);

    let data = await getData();
    let table = getTable(data);

    
    let table_div = format(table,fileName);
    var a = document.createElement('a');
    var data_type = 'data:application/vnd.ms-excel; charset=UTF-8';
    var table_html = escape(table_div);
    a.href = data_type + ', ' + table_html;
    a.download = (fileName || 'Worksheet')+'.xls';
    a.click();
    setExport(false);
  };

  return (
    <Button disabled={isExport}
      onClick={exportar}
    >
      {buttonText}
      {isExport ? (<>
        {' '}
        <Spinner
          animation="border"
          role="status"
          size="sm"
          style={!isExport ? { display: 'none' } : {}}
        />
      </>): ('')}
    </Button>
  );
};

export default ExportTable;
